var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-accordion',{attrs:{"label":_vm.historyLabel}},_vm._l((_vm.historyList),function(item,key){return _c('div',{key:key},[_c('history-item',{attrs:{"history-item":item}}),(_vm.shouldDisplaySeparator(key))?_c('hr',{staticClass:"solid"}):_vm._e()],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }